import { customerServiceProductsEntryPoint } from '@jira/jira-spa-apps-customer-service-products/entrypoint.tsx';
import { AsyncCustomersNav } from '@jira/jira-horizontal-nav-csm-customers/src/index.tsx';
import { l1CustomersProjectProviderResource } from '@jira/jira-router-resources-customer-service-l1-customers-project-provider/services/index.tsx';
import { customerServiceProductsRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceProductsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const customerServiceProductsPageEntryPoint = createPageEntryPoint({
	main: customerServiceProductsEntryPoint,
});

export const customerServiceProductsRouteEntry = createEntry(customerServiceProductsRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.products',
	layout: globalLayout,

	navigation: {
		horizontal: AsyncCustomersNav,
	},

	component: ErrorPagesNotFound,

	entryPoint() {
		return fg('berry-6285-customers-l1') ? customerServiceProductsPageEntryPoint : undefined;
	},

	resources: [...getNavigationResources(), l1CustomersProjectProviderResource],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceProductsRouteEntry.tsx',
			whichExportToUse: 'customerServiceProductsRouteEntry',
		},

		enabled: true,
	},
}));
